module.exports = __webpack_public_path__ + "img/startYourProject.01fde39d.png";